import React, { useState } from "react";

const FALLBACK_IMG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='225' viewBox='0 0 400 225'%3E%3Crect width='400' height='225' fill='%23141B24'/%3E%3Ctext x='200' y='120' text-anchor='middle' fill='%23B8BCC8' font-size='14' font-family='sans-serif'%3ENo preview available%3C/text%3E%3C/svg%3E";
const VISIBLE_TECH = 3;

const ProjectCard = ({ project, onOpenModal }) => {
    const [imgError, setImgError] = useState(false);

    const tech = project.techStack || [];
    const visibleTech = tech.slice(0, VISIBLE_TECH);
    const remainingCount = tech.length - VISIBLE_TECH;
    const techSnippet = visibleTech.join(" · ");

    return (
        <button
            type="button"
            className="project-card"
            onClick={() => onOpenModal(project.id)}
            aria-label={`View details for ${project.title}`}
        >
            {/* Media area — fixed aspect ratio, clean crop */}
            <div className="card-media">
                <img
                    src={imgError ? FALLBACK_IMG : project.imageUrl}
                    alt={`Screenshot of ${project.title}`}
                    loading="lazy"
                    onError={() => setImgError(true)}
                />
            </div>

            {/* Content body — always visible, structured hierarchy */}
            <div className="card-body">
                <div className="card-meta">
                    {project.category && (
                        <span className="card-category">{project.category}</span>
                    )}
                    {techSnippet && (
                        <span className="card-tech-brief">
                            {techSnippet}
                            {remainingCount > 0 && (
                                <span className="card-tech-more"> +{remainingCount}</span>
                            )}
                        </span>
                    )}
                </div>
                <h3 className="card-title">{project.title}</h3>
                <p className="card-desc">{project.shortDescription}</p>
                <div className="card-footer">
                    <span className="card-cta">View Details</span>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </div>
            </div>
        </button>
    );
};

export default ProjectCard;
